import { Controller } from "@hotwired/stimulus"
import { readFormParams, isVisible } from "./shared"

// Submit-time guards for the registration form: unverified promo-code confirm,
// mirrored reg-email/first-name/last-name sync, required-checkbox-group
// enforcement, and the accommodation-date-required guard.
export default class extends Controller {
  connect() {
    this.formParams = readFormParams(this.element)

    this._onSubmitClick = this._onSubmitClick.bind(this)
    this._onMirrorInput = this._onMirrorInput.bind(this)

    this.element.addEventListener("click", this._onSubmitClick)
    this.element.addEventListener("input", this._onMirrorInput)
    this.element.addEventListener("paste", this._onMirrorInput)
  }

  disconnect() {
    this.element.removeEventListener("click", this._onSubmitClick)
    this.element.removeEventListener("input", this._onMirrorInput)
    this.element.removeEventListener("paste", this._onMirrorInput)
  }

  _onMirrorInput(event) {
    const target = event.target
    if (target.matches(".reg-email")) {
      this._syncField("#user_registration_reg_email", target.value)
    } else if (target.matches(".reg-first-name")) {
      this._syncField("#user_registration_reg_first_name", target.value)
    } else if (target.matches(".reg-last-name")) {
      this._syncField("#user_registration_reg_last_name", target.value)
    }
  }

  _syncField(selector, value) {
    const hidden = this.element.querySelector(selector)
    if (hidden) hidden.value = value
  }

  _onSubmitClick(event) {
    if (!event.target.closest('input[type="submit"]')) return

    const locale = this.formParams.locale
    const promoField = this.element.querySelector(".promo-code-field")
    const promoCodeId = this.element.querySelector("#user_registration_promo_code_id")
    if (promoField && promoCodeId && promoField.value.length > 0 && promoCodeId.value.length === 0) {
      const message = locale === "en"
        ? "Promocode has not been verified. Do you want to submit the registration without using it?"
        : "Promokód nebyl ověřen. Chcete odeslat registraci bez jeho použití?"
      if (confirm(message)) {
        promoField.value = ""
      } else {
        promoField.focus()
        event.preventDefault()
        event.stopPropagation()
        return
      }
    }

    const emailField = this.element.querySelector(".reg-email")
    if (emailField) this._syncField("#user_registration_reg_email", emailField.value)
    const firstNameField = this.element.querySelector(".reg-first-name")
    if (firstNameField) this._syncField("#user_registration_reg_first_name", firstNameField.value)
    const lastNameField = this.element.querySelector(".reg-last-name")
    if (lastNameField) this._syncField("#user_registration_reg_last_name", lastNameField.value)

    this.element.dispatchEvent(new CustomEvent("registration:refresh", { bubbles: true }))

    this.element.querySelectorAll(".form-group.check_boxes.required").forEach((group) => {
      const boxes = group.querySelectorAll('input[type="checkbox"]')
      const anyChecked = Array.from(boxes).some((box) => box.checked)
      boxes.forEach((box) => { box.required = !anyChecked })
    })

    const missingDates = Array.from(
      this.element.querySelectorAll("input.nights-item, .accommodation-dates input")
    ).filter((el) => isVisible(el) && !el.value)
    if (missingDates.length > 0) {
      alert(locale === "en" ? "Choose a date for accommodation" : "Vyberte termín pro ubytování")
      event.preventDefault()
    }
  }
}
